<template>
  <div class="row contractedJourneysTable">
    <div class="col-12">
      <b-table
        :items="items"
        :fields="fields"
        :hover="true"
        :sort-by.sync="sortByTable"
        :sort-desc.sync="sortOrder"
        :per-page="perPage"
        :current-page="1"
        label-sort-asc=""
        label-sort-desc=""
        label-sort-clear=""
        sort-icon-right
        show-empty
        :no-border-collapse="true"
        responsive="lg"
        thead-class="table-thead text-center bg-transparent "
        tbody-class="table-tbody text-center cursor-pointer"
        ref="selectableTable"
        info="true"
        class="new-theme-custom-table"
        @row-clicked="(item) => $emit('row-clicked', item)"
        @sort-changed="handleSort"
        no-local-sorting
        >
        <template #empty> {{ $t("empty-row") }} </template>

        <template #head(selection)>
          <b-form-checkbox
            :checked="allPageRowsSelected"
            :indeterminate="somePageRowsSelected"
            @change="toggleCurrentPageSelection"
            @click.stop
          />
        </template>

        <template #cell(selection)="{ item }">
          <b-form-checkbox
            :checked="isRowSelected(item)"
            @change="(checked) => toggleRowSelection(item, checked)"
            @click.stop
          />
        </template>

        <template #cell(status)="{ item }">
          <div v-if="item.status" class="d-flex justify-content-center">
            <span
              :class="[
                'trip-status',
                {
                  on_hold_status:
                    item.status === 'Booking-Pending',
                },
                {
                  completed_status:
                    item.status === 'Booking-Confirmed' ||
                    item.status === 'Trip-Completed' ||
                    item.status === 'Trip-Completed-Note',
                },
                {
                  canceled_status:
                    item.status === 'Booking-Cancelled' ||
                    item.status === 'Booking-Cancelled-Note',
                },
                {
                  rescheduled_status:
                    item.status === 'Booking-Re-Assigned' ||
                    item.status === 'Trip-Arrived-At-Pickup-Location',
                },
                {
                  started_status:
                    item.status === 'Trip-Started' ||
                    item.status === 'Trip-Passenger-Picked-Up',
                },
                {
                  un_assigned_status:
                    item.status === 'Booking-Un-Assigned',
                },
                {
                  arrived_to_dropped_off_status:
                    item.status === 'Trip-Arrived-To-Dropped-Off',
                },
                {
                  dropped_off_status:
                    item.status === 'Trip-Passenger-Dropped-Off',
                },
              ]"
            >
              {{ $t(item.status) }}
            </span>
          </div>
        </template>
        <template #cell(sub_status)="{ item }">
          <div
            v-if="item.sub_status"
            v-b-tooltip.hover.top="$t(item.sub_status?.toLowerCase())"
            class="d-flex justify-content-center"
          >
            <div
              v-if="item.sub_status === 'Reviewed'"
              class="icon"
              style="background: var(--color-92)"
            >
              <img
                :src="require(`@/assets/images/icons/arrow-refresh-icon.svg`)"
                alt="arrow-refresh-icon"
              />
            </div>
            <div
              v-else-if="item.sub_status === 'Approval-Needed'"
              class="icon"
              style="background: var(--color-125)"
            >
              <img
                :src="require(`@/assets/images/icons/clock-1-icon.svg`)"
                alt="clock-icon"
              />
            </div>
            <div
              v-else-if="item.sub_status === 'Action-Required'"
              class="icon"
              style="background: var(--color-124)"
            >
              <img
                :src="require(`@/assets/images/icons/alert-triangle-icon.svg`)"
                alt="alert-triangle-icon"
              />
            </div>
            <div
              v-else-if="item.sub_status === 'Archived'"
              class="icon"
              style="background: var(--color-131)"
            >
              <img
                :src="require(`@/assets/images/icons/archive-icon.svg`)"
                alt="archived-icon"
                height="17"
              />
            </div>
          </div>
        </template>
      </b-table>
      <b-pagination
        v-model="currentPage"
        :total-rows="total"
        :per-page="perPage"
        first-number
        last-number
        aria-controls="my-table"
        class="d-flex justify-content-end"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    page: {
      type: Number,
      default: 1,
    },
    sortBy: {
      type: String,
      default: "-created_on",
    },
    sortDesc: {
      type: Boolean,
      default: false,
    },
    showUnifiedContractNo: {
      type: Boolean,
      default: false,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["change-page", "row-clicked", "toggle-row-selection", "toggle-page-selection"],
  data() {
    return {
      currentPage: this.page,
      sortByTable: this.sortBy.replace("-", ""),
      sortOrder: this.sortDesc,
      fields: [
        ...(this.selectable ? [{
          key: "selection",
          label: "",
          class: "align-middle",
          sortable: false,
        }] : []),
        {
          key: "reservation",
          label: this.$t("reservation-id"),
          class: "align-middle",
          thStyle: {
            backgroundPosition: "right .1rem center !important",
            paddingRight: "15px !important",
          },
          sortable: this.$route.name === "manage-trips",
        },
        {
          key: "contract",
          label: this.$t("contract-id"),
          class: "align-middle",
          sortable: false
        },
        {
          key: "reference_number",
          label: this.$t("reference-number"),
          class: "align-middle",
          sortable: false,
        },
        ...(this.showUnifiedContractNo ? [{
          key: "unifiedContractNo",
          label: this.$t("hajj-dawra-unified-contract-no"),
          class: "align-middle",
          sortable: false,
        }] : []),
        {
          key: "client",
          label: this.$t("client"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "sales_person",
          label: this.$t("sales-person"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "reservation_category",
          label: this.$t("sales-order-category"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "service",
          label: this.$t("service"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "service_category",
          label: this.$t("service-category"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "_id",
          label: this.$t("trip-id"),
          class: "align-middle",
          thStyle: {
            backgroundPosition: "right .1rem center !important",
            paddingRight: "15px !important",
          },
          sortable: true,
        },
        {
          key: "start",
          label: this.$t("pick-up-location"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "end",
          label: this.$t("drop-off-location"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "scheduledStartDate",
          label: this.$t("start-date"),
          class: "align-middle",
          thStyle: {
            backgroundPosition: "right .1rem center !important",
            paddingRight: "15px !important",
            minWidth: "80px",
          },
          sortable: true,
        },
        {
          key: "scheduledStartTime",
          label: this.$t("start-time"),
          class: "align-middle",
          thStyle: {
            backgroundPosition: "right .1rem center !important",
            paddingRight: "15px !important",
          },
          sortable: true,
        },
        {
          key: "scheduledEndDate",
          label: this.$t("end-date"),
          class: "align-middle",
          thStyle: {
            backgroundPosition: "right .1rem center !important",
            paddingRight: "15px !important",
            minWidth: "80px",
          },
          sortable: true,
        },
        {
          key: "scheduledEndTime",
          label: this.$t("end-time"),
          class: "align-middle",
          thStyle: {
            backgroundPosition: "right .1rem center !important",
            paddingRight: "15px !important",
          },
          sortable: true,
        },
        {
          key: "driver",
          label: this.$t("assigned-driver"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "secondaryDriver",
          label: this.$t("secondary-driver"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "driverMobileNumber",
          label: this.$t("mobile-number"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "vehicle",
          label: this.$t("assigned-vehicle"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "branch",
          label: this.$t("branch"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "status",
          label: this.$t("status"),
          class: "align-middle",
          sortable: false,
        },
        {
          key: "sub_status",
          label: this.$t("update"),
          class: "align-middle",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    currentPageIds() {
      return (this.items || []).map((item) => item?._id).filter(Boolean).map(String);
    },
    selectedIdSet() {
      return new Set((this.selectedIds || []).map(String));
    },
    selectedCurrentPageIds() {
      return this.currentPageIds.filter((id) => this.selectedIdSet.has(String(id)));
    },
    allPageRowsSelected() {
      return (
        this.currentPageIds.length > 0 &&
        this.selectedCurrentPageIds.length === this.currentPageIds.length
      );
    },
    somePageRowsSelected() {
      return (
        this.selectedCurrentPageIds.length > 0 &&
        this.selectedCurrentPageIds.length < this.currentPageIds.length
      );
    },
  },
  methods: {
    handleSort({ sortBy, sortDesc }) {
      if(!sortBy) return;
      this.$emit("sort-changed", { sortBy, sortDesc });
    },
    isRowSelected(item) {
      return this.selectedIdSet.has(String(item?._id || ""));
    },
    toggleRowSelection(item, checked) {
      this.$emit("toggle-row-selection", {
        id: item?._id,
        checked: Boolean(checked),
        item,
      });
    },
    toggleCurrentPageSelection(checked) {
      this.$emit("toggle-page-selection", {
        ids: this.currentPageIds,
        checked: Boolean(checked),
      });
    },
  },
  watch: {
    page(val) {
      if (this.currentPage !== val) this.currentPage = val;
    },
    currentPage(val) {
      this.$emit("change-page", val);
    },
  },
  i18n: {
    messages: {
      en: require("@/services/i18n/locales/en/manageTrips.json"),
      ar: require("@/services/i18n/locales/ar/manageTrips.json"),
    },
  },
};
</script>

<style lang="scss">
.contractedJourneysTable {
  .table.b-table {
    thead {
      tr {
        [aria-sort] {
          background-size: 13px !important;
        }
        th {
          font-size: 10px !important;
          padding-inline: 2px;
        }
      }
    }
    tbody {
      tr {
        td {
          font-size: 10px !important;
          padding: 2px;
        }
      }
      .trip-status {
        border-radius: 8px;
        font-size: 10px;
        font-weight: 700;
        padding: 5px;
      }
      .on_hold_status {
        background: var(--color-48);
        border: 1px solid var(--color-40);
        color: var(--color-29);
      }
      .completed_status {
        background: var(--color-19);
        border: 1px solid var(--color-16);
        color: var(--color-12);
      }
      .canceled_status {
        background: var(--color-20);
        border: 1px solid var(--color-39);
        color: var(--color-27);
      }
      .rescheduled_status {
        background: var(--color-18);
        border: 1px solid var(--color-41);
        color: var(--color-30);
      }
      .started_status {
        background: var(--color-52);
        border: 1px solid var(--color-41);
        color: var(--color-01);
      }
      .un_assigned_status {
        background: var(--color-47);
        border: 1px solid var(--color-39);
        color: var(--color-01);
      }
      .arrived_to_dropped_off_status {
        background: var(--color-130);
        border: 1px solid var(--color-41);
        color: var(--color-01);
      }
      .dropped_off_status {
        background: var(--color-05);
        border: 1px solid var(--color-41);
        color: var(--color-01);
      }
      .icon {
        height: 24px;
        width: 24px;
        padding: 0.4375rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
      }
    }
  }
}
</style>
